import React, { useState, useEffect } from "react";
import { supabase } from "../lib/supabaseClient.ts";
import CategoryGridMobile from "./AnimaliacatMobile.js";
import CategoryGridweb from "./AnimaliaCategorySection.js";
import "../css/CategorySection.css";
import CategoryGridwebb from "../CategoryGridwebb.js";

const imageMap = {
  cat: {
    "Alimentation": "img/chat/2.png",
    "Hygiène et soins": "img/chat/3.png",
    "Cage et Sacs de transports": "img/chat/4.png",
    "Gamelles et distributeur": "img/chat/5.png",
    "Arbre à chat et griffoirs": "img/chat/6.png",
    "Jouets": "img/chat/7.png",
    "Litière": "img/chat/8.png",
    "Sellerie": "img/chat/1.png",
  },
  dog: {
    "Alimentation": "img/chien/1.png",
    "Hygiène et soins ": "img/chien/2.png",
    "Couchages": "img/chien/3.png",
    "Gamelles et accessoires ": "img/chien/4.png",
    "Jouets": "img/chien/5.png",
    "Niches et cages": "img/chien/6.png",
    "Sellerie": "img/chien/7.png",
  },
};

const defaultImage = {
  cat: "img/chat/2.png",
  dog: "img/chien/1.png",
};

const CategoryGridd = () => {
  const [selectedType, setSelectedType] = useState("cat");
  const [categories, setCategories] = useState([]);
  const [showingSubcategoriesFor, setShowingSubcategoriesFor] = useState(null);
useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
}, []);

  useEffect(() => {
    const fetchData = async () => {
      const { data: catData, error: catError } = await supabase
        .from("categories")
        .select("id, name")
        .eq("pet_type", selectedType);

      if (catError) {
        console.error("Error fetching categories:", catError.message);
        return;
      }

      if (!catData || catData.length === 0) {
        setCategories([]);
        return;
      }

      const ids = catData.map((c) => c.id);
      const { data: subData, error: subError } = await supabase
        .from("subcategories")
        .select("id, name, category_id")
        .in("category_id", ids);

      if (subError) {
        console.error("Error fetching subcategories:", subError.message);
        return;
      }

      // Assign image: if category name not found in imageMap[selectedType], use defaultImage[selectedType]
      const combined = catData.map((cat) => ({
        ...cat,
        image: imageMap[selectedType][cat.name] || defaultImage[selectedType],
        subcategories: subData
          ? subData
              .filter((sub) => sub.category_id === cat.id)
              .map((s) => s.name)
          : [],
      }));

      setCategories(combined);
    };

    fetchData();
  }, [selectedType]);


  return (
    <>
      <div className="mobile-only">
        <CategoryGridMobile />
      </div>

      <div className="web-only">
        <CategoryGridwebb />
      </div>
    </>
    // <div style={{ padding: "20px" }}>
    //   <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
    //     {!showingSubcategoriesFor && (
    //       <div style={{ marginBottom: "20px", textAlign: "center" }}>
    //         <button
    //           onClick={() => {
    //             setSelectedType("cat");
    //             setShowingSubcategoriesFor(null);
    //           }}
    //           style={buttonStyle}
    //         >
    //           <img src="img/icon/w_pawprint.png" alt="Chat" style={iconStyle} />
    //           Catégories Chat
    //         </button>
    //         <button
    //           onClick={() => {
    //             setSelectedType("dog");
    //             setShowingSubcategoriesFor(null);
    //           }}
    //           style={buttonStyle}
    //         >
    //           <img src="img/icon/w_pawprint.png" alt="Chien" style={iconStyle} />
    //           Catégories Chien
    //         </button>
    //       </div>
    //     )}

    //     {showingSubcategoriesFor ? (
    //       <div style={{ textAlign: "center" }}>
    //         <Link to="#" onClick={() => setShowingSubcategoriesFor(null)} style={backButtonStyle}>
    //           <img src="img/icon/w_pawprint.png" alt="Retour" style={iconStyle} />
    //           Retour
    //         </Link>
    //         <h2 style={titleStyle}>
    //           Sous-catégories pour {showingSubcategoriesFor.name} {selectedType === "cat" ? "Chat" : "Chien"}
    //         </h2>
    //         <div style={subcategoryGridStyle}>
    //           {showingSubcategoriesFor.subcategories.map((sub, i) => {
    //             const folder = selectedType;
    //             const subImg = `/img/subcategories/${folder}/${sub
    //               .normalize("NFD")
    //               .replace(/[\u0300-\u036f]/g, "")
    //               .toLowerCase()
    //               .replace(/[^a-z0-9]/g, "_")}.png`;

    //             return (
    //               <div
    //                 key={i}
    //                 style={subcategoryCardStyle(subImg)}
                    
    //                 onClick={() => handleSubcategoryClick(showingSubcategoriesFor.name, sub)}
    //               >
    //                                 <div >{showingSubcategoriesFor.name}</div>

    //               </div>
    //             );
    //           })}
    //         </div>
    //       </div>
    //     ) : (
    //       <div style={mainCategoryGridStyle}>
    //         {categories.map((category, index) => (
    //           <div
    //             key={index}
    //             style={categoryCardStyle(category.image)}
    //             onClick={() => handleMainCategoryClick(category.name)}
    //           >
    //             <div style={categoryNameStyle}>{category.name}</div>
    //             {category.subcategories.length > 0 && (
    //               <div
    //                 onClick={(e) => {
    //                   e.stopPropagation();
    //                   setShowingSubcategoriesFor(category);
    //                 }}
    //                 style={subcategoryButtonStyle}
    //                 title="Voir les sous-catégories"
    //               >
    //                 ☰
    //               </div>
    //             )}
    //           </div>
    //         ))}
    //       </div>
    //     )}
    //   </div>
    // </div>
  );
};

export default CategoryGridd;

const buttonStyle = {
  padding: "8px 16px",
  marginRight: "12px",
  backgroundColor: "#ff69b4",
  color: "#fff",
  border: "none",
  borderRadius: "20px",
  fontWeight: "bold",
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  fontSize: "14px",
};

const iconStyle = { width: "14px", height: "14px" };

const backButtonStyle = {
  padding: "6px 12px",
  fontSize: "12px",
  backgroundColor: "#ff69b4",
  color: "#fff",
  borderRadius: "20px",
  display: "flex",
  alignItems: "center",
  gap: "6px",
  textDecoration: "none",
  width: "fit-content",
  cursor: "pointer",
  marginBottom: "25px",
};

const titleStyle = {
  marginBottom: "30px",
  fontSize: "28px",
  fontWeight: "700",
  textAlign: "center",
  color: "#333",
  background: "linear-gradient(to right,rgb(80, 79, 79),rgb(110, 107, 106))",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  letterSpacing: "1px",
  textTransform: "uppercase",
};

const subcategoryGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
  gap: "25px",
  justifyItems: "center",
  padding: "0 20px",
};

const subcategoryCardStyle = (imageUrl) => ({
  width: "100%",
  maxWidth: "220px",
  height: "240px",
  borderRadius: "16px",
  backgroundImage: `url(${imageUrl})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  cursor: "pointer",
});

const mainCategoryGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
  gap: "20px",
  justifyItems: "center",
  padding: "0 10px",
};

const categoryCardStyle = (imageUrl) => ({
  width: "100%",
  maxWidth: "200px",
  height: "200px",
  borderRadius: "16px",
  backgroundImage: `url(${imageUrl})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  fontWeight: "bold",
  color: "#fff",
  textAlign: "center",
  textShadow: "1px 1px 4px rgba(0,0,0,0.7)",
  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
  padding: "10px",
  cursor: "pointer",
  position: "relative",
});

const categoryNameStyle = {
  fontSize: "16px",
  backgroundColor: "rgba(0,0,0,0.5)",
  padding: "4px 10px",
  borderRadius: "8px",
};

const subcategoryButtonStyle = {
  position: "absolute",
  top: "10px",
  right: "10px",
  fontSize: "20px",
  cursor: "pointer",
  background: "rgba(0,0,0,0.4)",
  padding: "4px 8px",
  borderRadius: "6px",
};
